import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpUtilService } from '../http-util.service';

@Injectable({ providedIn: 'root' })
export class SalesmanReceiptService {
  private baseUrl = 'SalesmanReceiptService.asmx/';
  constructor(private http: HttpUtilService) {}
  getTerminalList(): Observable<any> { return this.http.get(this.baseUrl + 'GetTerminalList'); }
  getLastReceiptNo(): Observable<any> { return this.http.get(this.baseUrl + 'GetLastReceiptNo'); }
  getReceiptBySearch(searchText: string, searchOption: string): Observable<any> {
    return this.http.get(this.baseUrl + 'Search?searchOption=' + encodeURIComponent(JSON.stringify(searchOption)) + '&searchText=' + encodeURIComponent(JSON.stringify(searchText)));
  }
  getReceiptList(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'GetReceiptList?id=' + encodeURIComponent(JSON.stringify(id)));
  }
  getTotalAmount(ReceiptNo: string, ContractNo: string): Observable<any> {
    return this.http.get(this.baseUrl + 'GetTotalAmount?ReceiptNo=' + encodeURIComponent(JSON.stringify(ReceiptNo)) + '&ContractNo=' + encodeURIComponent(JSON.stringify(ContractNo)));
  }
  addReceipt(model: any): Observable<any> { return this.http.post(this.baseUrl + 'Add', { model }); }
  updateReceipt(model: any): Observable<any> { return this.http.post(this.baseUrl + 'Update', { model }); }
  deleteReceipt(receiptNo: string, deleteRemarks: string): Observable<any> {
    return this.http.post(this.baseUrl + 'Delete', { receiptNo, deleteRemarks });
  }
  printReceipt(ReceiptNo: string, ContractNo: string): Observable<any> {
    return this.http.post(this.baseUrl + 'SalesmanReceipt', { ReceiptNo, ContractNo });
  }
  transferReceipt(model: any): Observable<any> { return this.http.post(this.baseUrl + 'TransferReceipt', { model }); }
}
